import { useQuery } from "@tanstack/react-query";
import {
  EngagementBlueprintActivitiesParams,
  fetchEngagementBlueprintActivities
} from "PFCore/services/engagement_blueprints";
import { Activity, Id, PaginatedCollection } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { engagementBlueprintsKeys } from "./query_keys";

export const useEngagementBlueprintActivities = (
  engagementBlueprintId: Id,
  params: EngagementBlueprintActivitiesParams,
  options: QueryOptions<PaginatedCollection<Activity[]>> = {}
) =>
  useQuery({
    queryKey: engagementBlueprintsKeys.activities(engagementBlueprintId, params),
    queryFn: () => fetchEngagementBlueprintActivities(engagementBlueprintId, params),
    ...options
  });
